import { type AvailableDates } from '@avanta/shared/types/appointments';
import { type DailySlot } from 'types/appointments';

export const getAvailableDatesFromSlots = (dailySlots: DailySlot[]): AvailableDates =>
  Object.fromEntries(
    dailySlots
      .filter(dailySlot => dailySlot.times.length > 0)
      .map(dailySlot => [dailySlot.date, [...dailySlot.times].sort()])
  );
